import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { addRoles, getRoles, updateRoles } from "../../actions/userActions/roleAction";
import {
  getAllPermissionsGroup
} from "../../actions/userActions/permissionsAction";
import roleicon from "../../assets/images/roleicon.svg";
import { Redirect, useLocation, useHistory } from "react-router-dom";
import "./Roles.css";
import { CircularProgress, IconButton } from "@mui/material";
import HrComponent from "../reuse_components/HrComponent";
import BodyExtraSmallMedium from "../designSystem/BodyExtraSmallMedium";
import BodyLargeMedium from "../designSystem/BodyLargeMedium";
import closeModal from "../../assets/images/closeModal.svg";
import MultiSelect from "../designSystem/MultiSelect";
import "../DesignationLevel/DynamicModal.css"
import Textarea from "../designSystem/TextArea";
import TextField from "../designSystem/TextField";
import { validateFields } from "../../utils/Validations";
import { Check, X } from "lucide-react";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import CancelButton from '../subComponents/buttons/CustomCancelButton';
import PrimaryButton from '../subComponents/buttons/PrimaryButton';

import AddNewForm from "../addNew/AddNewForm";
import AddNewDrawer from "../addNew/AddNewDrawer";
import permissionIcon from "../../assets/images/Icon=Permissions.svg";

import { t } from "../../locales/translate";
function AddRoles({ onClose, editData, onSave }) {
  const dispatch = useDispatch();
  const initialValues = {
    name: "",
    description: "",
    roleGroup: [],
    active: false,
  };
  const [loading, setLoading] = useState(true); // Loading state
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(1);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerItem , setDrawerItem] = useState(null);
  const pageNumber = -1;
  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(getAllPermissionsGroup(pageNumber));
        if (editData) {
          const roleGroupIds = editData.permissionGroup.map(
            (item) => item.id
          );
          setFormValues({
            ...formValues,
            name: editData.name,
            description: editData.description,
            id: editData.id,
            active: editData.active,
            roleGroup: roleGroupIds,
          });
          setSelected(
            editData.roleGroupIds
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const extractRoleGroupIds = (permissionGroups) => {
    return permissionGroups.map((group) => group.id);
  };
  useEffect(() => {
    if (editData) {
      const roleGroupIds = editData.permissionGroup
        ? extractRoleGroupIds(editData.permissionGroup)
        : [];
      setFormValues({
        ...formValues,
        name: editData.name,
        description: editData.description,
        id: editData.id,
        active: editData.active,
        roleGroup: roleGroupIds
      });
    }
  }, []);
  const handletextChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleAddNew = (itemName) => {
  setDrawerItem(itemName);
  setDrawerOpen(true);
};

  const handleChange = (e) => {
    const { name, checked, type, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };
  const handleSave = async (e) => {
    e.preventDefault();
    const errors = validateFields(formValues, 'role');
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;
    if (editData) {
      await dispatch(updateRoles(formValues));
    } else {
      await dispatch(addRoles(formValues));
    }
    await onSave(formValues);
  };

  const allPermissionsGroup = useSelector(
    (state) => state.permissions_reducer.allPermissionsGroup
  );
  const getOptions = () => {
    return (
      (allPermissionsGroup &&
        allPermissionsGroup !== "isLoading" &&
        allPermissionsGroup.length !== 0 &&
        allPermissionsGroup.result &&
        allPermissionsGroup.result.length !== 0 &&
        allPermissionsGroup.result
          .filter((permissionGroup) => permissionGroup.active)
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((permissionGroup) => ({
            value: permissionGroup.id,
            label: permissionGroup.name,
          }))) ||
      []
    );
  };
  const handlePermissionGroupChange = (updatedValues) => {
    setFormValues((prevState) => ({
      ...prevState,
      roleGroup: updatedValues
    }));
  };
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '75vh' }}>
        <CircularProgress size={60} style={{ color: '#002D72' }} />
      </div>
    );
  }

  return (
    <>
      <div className="dynamicmodal-overlay">
        <div className="dynamicmodal-container">
          <div className="dynamicmodal-header mb-3">
            <div className="dynamicmodal-header-left">
              <div className="icon">
                <img src={roleicon} alt=" roleicon" />
              </div>
              <div className="text">
                <h2 className="modalheading">
                  {editData ? "Edit Role" :  `${t("addRole")}`}
                </h2>
                <p className="modaldescription">
                 {t("addRoleTip")}
                </p>
              </div>
            </div>
            <div className="dynamicmodal-header-right">
              <IconButton onClick={onClose}>
                <img src={closeModal} alt="" />
              </IconButton>
            </div>
          </div>
          <form onSubmit={handleSave}>
            <div className="dynamicmodal-body">
              <div className="dynamicmodal-form-group">
                <TextField
                  name='name'
                  label={`${t("name")} *`}
                  type='text'
                  value={formValues.name}
                  onChange={handletextChange}
                  placeholder={t("name")}
                  error={formErrors.name}
                />
              </div>

              <div className="dynamicmodal-form-group">
                <MultiSelect
                  isSearchable
                  onChange={handlePermissionGroupChange}
                  value={formValues?.roleGroup || []}
                  label={`${t("permissionGroup")} *`}
                  error={formErrors.roleGroup}
                  options={
                    allPermissionsGroup &&
                    allPermissionsGroup !== "isLoading" &&
                    allPermissionsGroup.result &&
                    allPermissionsGroup.result.length !== 0 &&
                    getOptions()
                  }
                  configKey={"permissionGroup"}
                  onAddNewClick={() => handleAddNew("permissionGroup")}
                />

              </div>
              <Textarea
                name='description'
                label={`${t("description")} *`}
                placeholder={t("description")}
                value={formValues.description}
                onChange={handletextChange}
                error={formErrors.description}
              />
              <div className=" mt-2 ml-0">
                <div
                  className="form-group"
                  style={{ display: "flex", alignItems: "flex-start" }}
                >
                  <input
                    name="active"
                    style={{ cursor: "pointer", height: "14px", width: "14px" }}
                    type="checkbox"
                    checked={formValues.active}
                    className="ml-1 mt-1"
                    onChange={handleChange}
                  />
                  <label
                    style={{ paddingLeft: "5px" }}
                    className="form-control-label"
                  >
                    <div style={{ padding: '2px' }}>
                      <BodySmallMedium text={t("active")} color="#1E293B" />
                    </div>
                  </label>
                </div>
              </div>
            </div>

            <div className="dynamicmodal-footer">
             <CancelButton
              onClick={onClose}
              text={t("cancel")}
              width={document.body.dir === "rtl" ? "119px" : ""}
              />
              <PrimaryButton
              text={t("save")}
              icon={Check}
              width={document.body.dir === "rtl" ? "123px" : ""}
              />
            </div>
          </form>
        </div>
      </div>
      <AddNewDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
           title={drawerItem? t("addItem").replace(/{{item}}/g, t(drawerItem)): ""}
          subtext={drawerItem ? t("createNewItemRecord").replace(/{{item}}/g, t(drawerItem)) : ""}
          icon={drawerItem  === "permissionGroup" ? <img src={permissionIcon} alt={drawerItem } /> : null}
        >
          {drawerItem  && (
           <AddNewForm
              itemName={drawerItem }
              onClose={() => setDrawerOpen(false)}
              onSave={(newData) => {
                if (drawerItem  === "permissionGroup") {
                  dispatch(getAllPermissionsGroup(pageNumber)).then(() => {
                    setFormValues((prev) => ({
                      ...prev,
                      value: newData.id,
                      label: newData.name
                    }));
                  });
                }
              }}
            />

          )}
</AddNewDrawer>
    </>
  );
}

export default AddRoles;
